import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver';

const exportExcelCustomer = (filteredData) => {
    if (!filteredData || !Array.isArray(filteredData)) {
        console.error("Invalid customer Data.");
        return;
    }

    const formattedData = filteredData.map(item => {
        const address = item?.address?.address ?? "";
        const zipMatch = address.match(/\b\d{4}\b/);
        const zipCode = zipMatch ? zipMatch[0] : "N/A";

        return {
            Email: item?.email ?? "NA",
            FirstName: item?.firstName ?? "NA",
            LastName: item?.lastName ?? "NA",
            PhoneNumber: item?.address?.addressPhoneNumber ?? "NA",
            Address: address ?? "NA",
            Tags: Array.isArray(item?.tags) && item.tags.length
                ? item.tags
                    .map(tag => typeof tag === "object"
                        ? (tag.display_name || tag.name)
                        : String(tag)
                    )
                    .join(", ")
                : "No Tags",
            TotalAmount: item?.totalAmount ?? "NA",
            TotalOrders: item?.totalOrders ?? "NA",
            LastOrderDate: item?.lastOrderDate
                ? new Date(item.lastOrderDate).toLocaleDateString("en-IN", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric"
                })
                : "N/A",
            ZipCode: zipCode
        };
    });

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet);

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });

    const filename = "customer_Data.xlsx";

    saveAs(dataBlob, filename);
}

export default exportExcelCustomer;



